import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'

function BasicFilterPopover({ column, params, setParams, onClose, onSetHandleApply, canEdit = true, hideApplyButton = false }) {
  const searchKey = column.accessor_key
  const operatorKey = `${column.accessor_key}Operator`
  const [operator, setOperator] = useState(params[operatorKey] || 'contains')
  const [value, setValue] = useState(params[searchKey] || '')

  // Track initial values to detect changes
  const initialOperator = useRef(params[operatorKey] || 'contains')
  const initialValue = useRef(params[searchKey] || '')

  const textOperators = ['contains', 'equals', 'not_contains', 'starts_with', 'ends_with']

  const handleOperatorChange = (e) => {
    if (!canEdit) return
    const newOperator = e.target.value
    setOperator(newOperator)

    // Clear the search field if operator doesn't use text input
    if (!textOperators.includes(newOperator)) {
      setValue('')
    }
  }

  const handleApply = () => {
    // Only update params if values have changed
    const hasChanges = value !== initialValue.current || operator !== initialOperator.current

    if (hasChanges) {
      // Get the current params to ensure we have the latest sort state
      setParams(currentParams => {
        const newParams = {
          ...currentParams,
          [searchKey]: value,
          [operatorKey]: operator
        }
        return newParams
      })
    }
    onClose()
  }

  useEffect(() => {
    if (onSetHandleApply) {
      onSetHandleApply(handleApply)
    }
  }, [value, operator]) // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-apply changes when hideApplyButton is true
  useEffect(() => {
    if (hideApplyButton) {
      setParams(currentParams => ({
        ...currentParams,
        [searchKey]: value,
        [operatorKey]: operator
      }))
    }
  }, [value, operator, hideApplyButton, setParams, searchKey, operatorKey])

  const handleClear = () => {
    setValue('')
    setOperator('contains')
    const newParams = {
      ...params,
      [searchKey]: '',
      [operatorKey]: 'contains' // Reset operator to default 'contains'
    }
    setParams(newParams)
  }

  return (
    <div>
      <div className="mb-3">
        <strong>{column.name}</strong>
      </div>

      <div className="mb-3">
        <Form.Select value={operator} onChange={handleOperatorChange} size="sm" disabled={!canEdit}>
          <option value="contains">contains</option>
          <option value="equals">equals</option>
          <option value="not_contains">does not contain</option>
          <option value="starts_with">starts with</option>
          <option value="ends_with">ends with</option>
          {column.accessor_key !== 'id' && (
            <>
              <option value="is_empty">is empty</option>
              <option value="is_not_empty">is not empty</option>
            </>
          )}
        </Form.Select>
      </div>

      <div className="mb-3">
        <Form.Control
          type="text"
          placeholder={`Search ${column.name}`}
          value={value}
          onChange={(e) => canEdit && setValue(e.target.value)}
          disabled={!canEdit || !textOperators.includes(operator)}
          size="sm"
        />
      </div>

      {!hideApplyButton && (
        <div className="d-flex justify-content-between gap-2">
          {canEdit && (
            <Button variant="light" size="sm" onClick={handleClear}>
              Clear
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={canEdit ? handleApply : onClose}>
            {canEdit ? 'Apply' : 'Close'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default BasicFilterPopover
